import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { NotACashGrabSection } from '../components/NotACashGrabSection';
import { ChillsSection } from '../components/ChillsSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { PricingSection } from '../components/PricingSection';
import { AverageRatingSection } from '../components/AverageRatingSection';
import { TestimonialsGridSection } from '../components/TestimonialsGridSection';
import { UrgencySection } from '../components/UrgencySection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { SocialProofNotification } from '../components/SocialProofNotification';
export const LandingV1 = () => <div className="w-full min-h-screen bg-bttf-bg text-bttf-text" data-id="element-1487">
    <Header data-id="element-1488" />
    <main data-id="element-1489">
      <HeroSection data-id="element-1490" />
      <NotACashGrabSection data-id="element-1491" />
      <ChillsSection data-id="element-1492" />
      <WhatsInsideSection data-id="element-1493" />
      <SocialProofSection data-id="element-1494" />
      <PricingSection data-id="element-1495" />
      <AverageRatingSection data-id="element-1496" />
      <TestimonialsGridSection data-id="element-1497" />
      <UrgencySection data-id="element-1498" />
      <FAQSection data-id="element-1499" />
    </main>
    <Footer data-id="element-1500" />
    <SocialProofNotification data-id="element-1501" />
  </div>;